import React from "react";
import styled from "styled-components";
import theme from "../../../styles/theme";
import bodyStyles from "./bodyStyles";

const {
	colors,
	breakPoints: { screenQuery },
} = theme;

const Body1 = styled.p(
	bodyStyles,
	`
  color: ${colors.black};
  font-size: 24px;
  line-height: 32px;
  ${screenQuery.large}{
    font-size: 22px;
    line-height: 28px;
  }
  ${screenQuery.small}{
    font-size: 20px;
    line-height: 26px;
  }
  p {
    font-size: 24px;
    line-height: 32px;
    ${screenQuery.large}{
      font-size: 22px;
      line-height: 28px;
    }
    ${screenQuery.small}{
      font-size: 20px;
      line-height: 26px;
    }
  }
`
);
export default ({ children, ...props }) => <Body1 {...props}>{children}</Body1>;
